<template>
    <div>
        <section class="section" id="overview">
            <div class="columns">
                <div class="column is-6-desktop is-offset-3-desktop is-10-tablet is-12-mobile is-offset-1-tablet">
                    <h1 class="title has-text-centered is-size-2-desktop is-size-2-tablet is-size-3-mobile has-text-weight-bold">
                        The review and marketing platform that gets you found.</h1>
                    <p class="is-size-6-desktop has-text-centered">Collecting reviews and engaging with your customers
                        on Hellopeter's platform helps your business build trust, get discovered and stand out in search
                        results.</p>
                </div>
            </div>
            <div class="container mobile-left-right-padding">
                <div class="columns is-mobile is-multiline">
                    <div class="column is-3-tablet is-half-mobile">
                        <div class="image is-centered is-hover">
                            <img src="/static/img/features/icons/Get-found-icon.svg" alt="Get Found"
                                 @click.prevent="jumpTo('getfound_')"/>
                        </div>
                        <p class="is-size-6-tablet has-text-centered has-text-weight-bold is-uppercase">get found</p>
                    </div>
                    <div class="column is-3-tablet is-half-mobile">
                        <div class="image is-centered is-hover">
                            <img src="/static/img/features/icons/Build-trust-icon.svg" alt="Build Trust"
                                 @click.prevent="jumpTo('buildtrust_')"/>
                        </div>
                        <p class="is-size-6-tablet has-text-centered has-text-weight-bold is-uppercase">build trust</p>
                    </div>
                    <div class="column is-3-tablet is-half-mobile">
                        <div class="image is-centered is-hover">
                            <img src="/static/img/features/icons/Engage-icon.svg" alt="Engage"
                                 @click.prevent="jumpTo('engage_')"/>
                        </div>
                        <p class="is-size-6-tablet has-text-centered has-text-weight-bold is-uppercase">engage</p>
                    </div>
                    <div class="column is-3-tablet is-half-mobile">
                        <div class="image is-centered is-hover">
                            <img src="/static/img/features/icons/Measure-Learn-icon.svg" alt="Measure And Learn"
                                 @click.prevent="jumpTo('measure_')"/>
                        </div>
                        <p class="is-size-6-tablet has-text-centered has-text-weight-bold is-uppercase">measure &amp;
                            learn</p>
                    </div>
                </div>
            </div>
        </section>
        <!-- Get a listing, and get found -->
        <a id="getfound_"></a>
        <section class="section" id="get-found">
            <!-- TABLET AND DESKTOP -->
            <div class="columns is-hidden-mobile">
                <div class="column is-6-desktop is-offset-3-desktop is-10-tablet is-offset-1-tablet ">
                    <article class="media">
                        <figure class="media-left">
                            <p class="image get-found-image">
                                <img src="/static/img/features/desktop/get-found-icon.svg"
                                     alt="Get a listing, get found"/>
                            </p>
                        </figure>
                        <div class="media-content">
                            <div class="content">
                                <h1>Get a listing, get found</h1>
                                <p>Become discoverable by featuring on South Africa's number 1 consumer review platform,
                                    and make your Google organic search results stand out with your Hellopeter business
                                    profile.</p>
                            </div>
                        </div>
                    </article>
                </div>
            </div>
            <div class="columns is-hidden-mobile">
                <div class="column is-full-tablet">
                    <img id="get-found-image" src="/static/img/features/desktop/get-found-image.png"
                         alt="Get a listing, get found"
                         srcset="/static/img/features/desktop/get-found-image@2x.png 2x"/>
                </div>
            </div>
            <div class="container is-hidden-mobile">
                <div class="columns">
                    <div class="column is-one-quarter-tablet">
                        <img id="google-presence-icon" src="/static/img/features/icons/google-presence-icon.svg"
                             alt="Your Google presence"/>
                        <p class="is-size-6-tablet has-text-weight-bold small-top-bottom-margin">Your Google
                            presence</p>
                        <p class="is-size-6-tablet listing-blurb">Hellopeter business profile pages claim top spot on
                            Google search when searchers type "(company name) reviews." Improve what searchers see by
                            collecting reviews.</p>
                    </div>
                    <div class="column is-one-quarter-tablet">
                        <img id="rich-snippets-icon" src="/static/img/features/icons/rich-snippets-icon.svg"
                             alt="Google star ratings"/>
                        <p class="is-size-6-tablet has-text-weight-bold small-top-bottom-margin">Google star ratings</p>
                        <p class="is-size-6-tablet listing-blurb">Improve your chances of standing out from your
                            competition and get more traffic by displaying your Hellopeter star ratings on your Google
                            search results.</p>
                    </div>
                    <div class="column is-one-quarter-tablet">
                        <img id="on-site-presence-icon" src="/static/img/features/icons/onsite-presence-icon.svg"
                             alt="Onsite presence"/>
                        <p class="is-size-6-tablet has-text-weight-bold small-top-bottom-margin">Onsite presence</p>
                        <p class="is-size-6-tablet listing-blurb">Hellopeter has 28,000 daily visitors. By building your
                            Hellopeter profile you can get found by new customers on the search for great products and
                            services.</p>
                    </div>
                    <div class="column is-one-quarter-tablet">
                        <img id="top-business-icon" src="/static/img/features/icons/top-business-icon.svg"
                             alt="Be a Top Business"/>
                        <p class="is-size-6-tablet has-text-weight-bold small-top-bottom-margin">Be a Top Business</p>
                        <p class="is-size-6-tablet listing-blurb">Hellopeter top business pages claim high rankings on
                            Google when searchers type "(Industry reviews)." Get listed on our Top Business page and
                            become more discoverable.</p>
                    </div>
                </div>
            </div>
            <!-- MOBILE ONLY -->
            <div class="columns is-mobile is-hidden-tablet">
                <div class="column is-12">
                    <p class="image get-found-image">
                        <img src="/static/img/features/desktop/get-found-icon.svg" alt="Get a listing, get found"/>
                    </p>
                    <h1 class="title has-text-weight-bold has-text-centered">Get a listing, get found</h1>
                    <p class="has-text-centered">Become discoverable by featuring on South Africa’s number 1 consumer
                        review platform, and make your Google organic search results stand out with your Hellopeter
                        business profile.</p>
                    <carousel :per-page="slidesPerPage" paginationActiveColor="#30aee1">
                        <slide>
                            <div class="image">
                                <img id="slide-google-presence" src="/static/img/features/mobile/Get-found-01.png"
                                     alt="Your Google presence"
                                     srcset="/static/img/features/mobile/Get-found-01@2x.png 2x, /static/img/features/mobile/Get-found-01@3x.png 3x"/>
                            </div>
                            <p class="has-text-weight-bold has-text-centered small-top-bottom-margin">Your Google
                                presence</p>
                            <p class="has-text-centered">Hellopeter business profile pages claim top spot on Google
                                search when searcher type "(company name) reviews." Improve what searcher see by
                                collecting reviews.</p>
                        </slide>
                        <slide>
                            <div class="image">
                                <img id="slide-google-presence-2" src="/static/img/features/mobile/Get-found-01.png"
                                     alt="Google star ratings"
                                     srcset="/static/img/features/mobile/Get-found-01@2x.png 2x, /static/img/features/mobile/Get-found-01@3x.png 3x"/>
                            </div>
                            <p class="has-text-weight-bold has-text-centered small-top-bottom-margin">Google star
                                ratings</p>
                            <p class="has-text-centered">Improve your chances of standing out from your competition and
                                get more traffic by displaying your Hellopeter star ratings on your Google search
                                results.</p>
                        </slide>
                        <slide>
                            <div class="image">
                                <img id="slide-top-business" src="/static/img/features/mobile/Get-found-04.png"
                                     alt="Be a Top Business"
                                     srcset="/static/img/features/mobile/Get-found-04@2x.png 2x, /static/img/features/mobile/Get-found-04@3x.png 3x"/>
                            </div>
                            <p class="has-text-weight-bold has-text-centered small-top-bottom-margin">Onsite
                                presence</p>
                            <p class="has-text-centered">Hellopeter has 28,000 daily visitors. By building your
                                Hellopeter profile you can get found by new customers on the search for great products
                                and services.</p>
                        </slide>
                        <slide>
                            <div class="image">
                                <img id="slide-google-star-ratings" src="/static/img/features/mobile/Get-found-02.png"
                                     alt="Google star ratings"
                                     srcset="/static/img/features/mobile/Get-found-02@2x.png 2x, /static/img/features/mobile/Get-found-02@3x.png 3x"/>
                            </div>
                            <p class="has-text-weight-bold has-text-centered small-top-bottom-margin">Be a Top
                                Business</p>
                            <p class="has-text-centered">Hellopeter top business pages claim high rankings on Google
                                when searchers type "(Industry reviews)." Get listed on our Top Business page and become
                                more discoverable.</p>
                        </slide>
                    </carousel>
                </div>
            </div>
        </section>
        <!-- BUILD A BRAND -->
        <a id="buildtrust_"></a>
        <section class="section" id="build-a-brand">
            <!-- TABLET AND DESKTOP -->
            <div class="columns is-hidden-mobile">
                <div class="column is-8-desktop is-offset-3-desktop is-10-tablet is-offset-1-tablet ">
                    <article class="media">
                        <figure class="media-left">
                            <p class="image build-a-brand-image">
                                <img src="/static/img/features/icons/build-a-brand-icon.svg"
                                     alt="Build a brand that your customers trust"/>
                            </p>
                        </figure>
                        <div class="media-content">
                            <div class="content">
                                <h1>Build a brand that your customers trust</h1>
                                <p>Let your customer reviews speak for your business. Collect more reviews and showcase
                                    them to increase customer confidence and boost sales.</p>
                            </div>
                        </div>
                    </article>
                </div>
            </div>
            <div class="columns is-hidden-mobile">
                <div class="column is-full-tablet">
                    <img id="build-a-brand-image" src="/static/img/features/desktop/build-a-brand-image.png"
                         alt="Build a brand that your customers trust"
                         srcset="/static/img/features/desktop/build-a-brand-image@2x.png 2x"/>
                </div>
            </div>
            <div class="container is-hidden-mobile">
                <div class="columns">
                    <div class="column is-one-third-tablet is-3-desktop is-offset-2-desktop">
                        <img id="collect-more-reviews-icon"
                             src="/static/img/features/icons/collect-more-reviews-icon.svg" alt="Collect more reviews"/>
                        <p class="is-size-6-tablet has-text-weight-bold small-top-bottom-margin">Collect more
                            reviews</p>
                        <p class="is-size-6-tablet listing-blurb">Your customers are your best marketers! The Hellopeter
                            review collection tools make it easy for your business to start scaling your customer
                            testimonials.</p>
                    </div>
                    <div class="column is-one-third-tablet is-3-desktop">
                        <img id="trust-index-rating-icon" src="/static/img/features/icons/trust-index-rating-icon.svg"
                             alt="TrustIndex ratings and reviews"/>
                        <p class="is-size-6-tablet has-text-weight-bold small-top-bottom-margin">TrustIndex ratings and
                            reviews</p>
                        <p class="is-size-6-tablet listing-blurb">Increase sales by displaying your reviews, TrustIndex,
                            and other Hellopeter rating widgets on your business’s website, email, and other marketing
                            collateral.</p>
                    </div>
                    <div class="column is-one-third-tablet is-3-desktop">
                        <img id="social-share-icon" src="/static/img/features/icons/social-share-icon.svg"
                             alt="Social sharing"/>
                        <p class="is-size-6-tablet has-text-weight-bold small-top-bottom-margin">Social sharing</p>
                        <p class="is-size-6-tablet listing-blurb">Increase your exposure by sharing reviews to your
                            social media pages. Facebook is a perfect place to share feedback you’ve received from loyal
                            customers and showcase trust.</p>
                    </div>
                </div>
            </div>
            <!-- MOBILE ONLY -->
            <div class="columns is-mobile is-hidden-tablet">
                <div class="column is-12">
                    <p class="image build-a-brand-image">
                        <img src="/static/img/features/icons/build-a-brand-icon.svg"
                             alt="Build a brand that your customers trust"/>
                    </p>
                    <h1 class="title has-text-weight-bold has-text-centered">Build a brand that your customers
                        trust</h1>
                    <p class="has-text-centered mar-bottom-only">Let your customer reviews speak for your business.
                        Collect more reviews and showcase them to increase customer confidence and boost sales.</p>
                    <carousel :per-page="slidesPerPage" paginationActiveColor="#58595b" paginationColor="#cccccc">
                        <slide>
                            <div class="image">
                                <img id="slide-collect-reviews" src="/static/img/features/mobile/brand-image.png"
                                     alt="Collect more reviews"
                                     srcset="/static/img/features/mobile/brand-image@2x.png 2x, /static/img/features/mobile/brand-image@3x.png 3x"/>
                            </div>
                            <p class="has-text-weight-bold has-text-centered small-top-bottom-margin">Collect more
                                reviews</p>
                            <p class="has-text-centered">Your customers are your best marketers! The Hellopeter review
                                collection tools make it easy for your business to start scaling your customer
                                testimonials.</p>
                        </slide>
                        <slide>
                            <div class="image">
                                <img id="slide-trust-index" src="/static/img/features/mobile/brand-image-02.png"
                                     alt="TrustIndex ratings and reviews"
                                     srcset="/static/img/features/mobile/brand-image-02@2x.png 2x, /static/img/features/mobile/brand-image-02@3x.png 3x"/>
                            </div>
                            <p class="has-text-weight-bold has-text-centered small-top-bottom-margin">TrustIndex ratings
                                and reviews</p>
                            <p class="has-text-centered">Increase sales by displaying your reviews, TrustIndex, and
                                other Hellopeter rating widgets on your business’s website, email, and other marketing
                                collateral.</p>
                        </slide>
                        <slide>
                            <div class="image">
                                <img id="slide-social-sharing" src="/static/img/features/mobile/brand-image-03.png"
                                     alt="Social sharing"
                                     srcset="/static/img/features/mobile/brand-image-03@2x.png 2x, /static/img/features/mobile/brand-image-03@3x.png 3x"/>
                            </div>
                            <p class="has-text-weight-bold has-text-centered small-top-bottom-margin">Social sharing</p>
                            <p class="has-text-centered">Increase your exposure by sharing reviews to your social media
                                pages. Facebook is a perfect place to share feedback you’ve received from loyal
                                customers and showcase trust.</p>
                        </slide>
                    </carousel>
                </div>
            </div>
        </section>
        <!-- ENGAGE -->
        <a id="engage_"></a>
        <section class="section" id="engage">
            <!-- TABLET AND DESKTOP -->
            <div class="columns is-hidden-mobile">
                <div class="column is-8-desktop is-offset-3-desktop is-12-tablet">
                    <article class="media">
                        <figure class="media-left">
                            <p class="image engage-image">
                                <img src="/static/img/features/icons/engage-icon-image.svg"
                                     alt="Engage with your customers"/>
                            </p>
                        </figure>
                        <div class="media-content">
                            <div class="content">
                                <h1>Engage with your customers</h1>
                                <p>Customer service matters. Do more than simply manage your reviews, connect with your
                                    customers and make every experience meaningful.</p>
                            </div>
                        </div>
                    </article>
                </div>
            </div>
            <div class="columns is-hidden-mobile">
                <div class="column is-full-tablet">
                    <img id="engage-image" src="/static/img/features/desktop/engage-image.png"
                         alt="Engage with your customers" srcset="/static/img/features/desktop/engage-image@2x.png 2x"/>
                </div>
            </div>
            <div class="container is-hidden-mobile">
                <div class="columns tablet-outer-pad">
                    <div class="column is-half-tablet is-one-quarter-desktop is-offset-one-quarter-desktop">
                        <img id="manage-reviews-icon" src="/static/img/features/icons/manage-reviews-icon.svg"
                             alt="Manage reviews"/>
                        <p class="is-size-6-tablet has-text-weight-bold small-top-bottom-margin">Manage reviews</p>
                        <p class="is-size-6-tablet listing-blurb">Use the Hellopeter business portal to get notified,
                            access reviews, respond publicly and privately, and apply templated responses to ensure that
                            your customers are heard.</p>
                    </div>
                    <div class="column is-half-tablet is-one-quarter-desktop">
                        <img id="collect-nps-icon" src="/static/img/features/icons/collect-nps-icon.svg"
                             alt="Collect and measure your NPS"/>
                        <p class="is-size-6-tablet has-text-weight-bold small-top-bottom-margin">Collect and measure
                            your NPS</p>
                        <p class="is-size-6-tablet listing-blurb">No business has a perfect record. Negative sentiment
                            is part of your business – learn from it and create lifetime customers by converting
                            detractors into brand promoters.</p>
                    </div>
                </div>
            </div>
            <!-- MOBILE ONLY -->
            <div class="columns is-mobile is-hidden-tablet">
                <div class="column is-12">
                    <p class="image engage-image">
                        <img src="/static/img/features/icons/engage-icon-image.svg" alt="Engage with your customers"/>
                    </p>
                    <h1 class="title has-text-weight-bold has-text-centered">Engage with your customers</h1>
                    <p class="has-text-centered">Customer service matters. Do more than simply manage your reviews,
                        connect with your customers and make every experience meaningful.</p>
                    <carousel :per-page="slidesPerPage" paginationActiveColor="#3074e1">
                        <slide>
                            <div class="image">
                                <img id="slide-manage-reviews" src="/static/img/features/mobile/engage-image.png"
                                     alt="Manage reviews"
                                     srcset="/static/img/features/mobile/engage-image@2x.png 2x, /static/img/features/mobile/engage-image@3x.png 3x"/>
                            </div>
                            <p class="has-text-weight-bold has-text-centered small-top-bottom-margin">Manage reviews</p>
                            <p class="has-text-centered">Use the Hellopeter business portal to get notified, access
                                reviews, respond publicly and privately, and apply templated responses to ensure that
                                your customers are heard.</p>
                        </slide>
                        <slide>
                            <div class="image">
                                <img id="slide-collect-nps" src="/static/img/features/mobile/engage-image-02.png"
                                     alt="Collect and measure your NPS"
                                     srcset="/static/img/features/mobile/engage-image-02@2x.png 2x, /static/img/features/mobile/engage-image-02@3x.png 3x"/>
                            </div>
                            <p class="has-text-weight-bold has-text-centered small-top-bottom-margin">Collect and
                                measure your NPS</p>
                            <p class="has-text-centered">No business has a perfect record. Negative sentiment is part of
                                your business – learn from it and create lifetime customers by converting detractors
                                into brand promoters.</p>
                        </slide>
                    </carousel>
                </div>
            </div>
        </section>
        <!-- DATA INFORM -->
        <a id="measure_"></a>
        <section class="section" id="data-inform">
            <!-- TABLET AND DESKTOP -->
            <div class="columns is-hidden-mobile">
                <div class="column is-8-desktop is-offset-3-desktop is-12-tablet">
                    <article class="media">
                        <figure class="media-left">
                            <p class="image data-inform-image">
                                <img src="/static/img/features/icons/data-inform-icon.svg"
                                     alt="Let your data inform you "/>
                            </p>
                        </figure>
                        <div class="media-content">
                            <div class="content">
                                <h1>Let your data inform you </h1>
                                <p>Access rich customer and review data to better understand your customers as well as
                                    onsite and Google Analytics data to make smarter decisions.</p>
                            </div>
                        </div>
                    </article>
                </div>
            </div>
            <div class="columns is-hidden-mobile">
                <div class="column is-full-tablet">
                    <img id="data-inform-image" src="/static/img/features/desktop/data-image.png"
                         alt="Let your data inform you" srcset="/static/img/features/desktop/data-image@2x.png 2x"/>
                </div>
            </div>
            <div class="container is-hidden-mobile">
                <div class="columns">
                    <div class="column is-one-quarter-tablet">
                        <img id="dashboard-icon" src="/static/img/features/icons/data-inform-dashboard.svg"
                             alt="Dashboard"/>
                        <p class="is-size-6-tablet has-text-weight-bold small-top-bottom-margin">Dashboard</p>
                        <p class="is-size-6-tablet listing-blurb">Understand how your business is performing at a
                            glance, identify trends and measure progress.</p>
                    </div>
                    <div class="column is-one-quarter-tablet">
                        <img id="reporting-icon" src="/static/img/features/icons/data-inform-reporting.svg"
                             alt="Reporting"/>
                        <p class="is-size-6-tablet has-text-weight-bold small-top-bottom-margin">Reporting</p>
                        <p class="is-size-6-tablet listing-blurb">Get a handle of your review data and compare to other
                            businesses in your industry.</p>
                    </div>
                    <div class="column is-one-quarter-tablet">
                        <img id="on-site-icon" src="/static/img/features/icons/data-inform-onsite.svg"
                             alt="Onsite &amp; Google Analytics reporting"/>
                        <p class="is-size-6-tablet has-text-weight-bold small-top-bottom-margin">Onsite &amp; Google
                            Analytics reporting</p>
                        <p class="is-size-6-tablet listing-blurb">Understand how people find your business, and how much
                            traffic Google drives to your profile.</p>
                    </div>
                    <div class="column is-one-quarter-tablet">
                        <img id="agent-reporting-icon" src="/static/img/features/icons/data-inform-agent.svg"
                             alt="Agent reporting"/>
                        <p class="is-size-6-tablet has-text-weight-bold small-top-bottom-margin">Agent reporting</p>
                        <p class="is-size-6-tablet listing-blurb">For larger teams, understand how your agents perform
                            and identify opportunities for improvement.</p>
                    </div>
                </div>
            </div>
            <!-- MOBILE ONLY -->
            <div class="columns is-mobile is-hidden-tablet">
                <div class="column is-12">
                    <p class="image data-inform-image">
                        <img src="/static/img/features/icons/data-inform-icon.svg" alt="Let your data inform you "/>
                    </p>
                    <h1 class="title has-text-weight-bold has-text-centered">Let your data inform you </h1>
                    <p class="has-text-centered">Access rich customer and review data to better understand your
                        customers as well as onsite and Google Analytics data to make smarter decisions.</p>
                    <carousel :per-page="slidesPerPage" paginationActiveColor="#58595b" pagination-color="#cccccc">
                        <slide>
                            <div class="image">
                                <img id="slide-dashboard" src="/static/img/features/mobile/data-image.png"
                                     alt="Manage reviews"
                                     srcset="/static/img/features/mobile/data-image@2x.png 2x, /static/img/features/mobile/data-image@3x.png 3x"/>
                            </div>
                            <p class="has-text-weight-bold has-text-centered small-top-bottom-margin">Dashboard</p>
                            <p class="has-text-centered">Understand how your business is performing at a glance,
                                identify trends and measure progress.</p>
                        </slide>
                        <slide>
                            <div class="image">
                                <img id="slide-reporting" src="/static/img/features/mobile/data-image-02.png"
                                     alt="Reporting"
                                     srcset="/static/img/features/mobile/data-image-02@2x.png 2x, /static/img/features/mobile/data-image-02@3x.png 3x"/>
                            </div>
                            <p class="has-text-weight-bold has-text-centered small-top-bottom-margin">Reporting</p>
                            <p class="has-text-centered">Get a handle of your review data and compare to other
                                businesses in your industry.</p>
                        </slide>
                        <slide>
                            <div class="image">
                                <img id="slide-onsite-google" src="/static/img/features/mobile/data-image-03.png"
                                     alt="Onsite &amp; Google Analytics reporting"
                                     srcset="/static/img/features/mobile/data-image-03@2x.png 2x, /static/img/features/mobile/data-image-03@3x.png 3x"/>
                            </div>
                            <p class="has-text-weight-bold has-text-centered small-top-bottom-margin">Onsite &amp;
                                Google Analytics reporting</p>
                            <p class="has-text-centered">Understand how people find your business, and how much traffic
                                Google drives to your profile.</p>
                        </slide>
                        <slide>
                            <div class="image">
                                <img id="slide-onsite-google-2" src="/static/img/features/mobile/data-image-03.png"
                                     alt="Agent reporting"
                                     srcset="/static/img/features/mobile/data-image-03@2x.png 2x, /static/img/features/mobile/data-image-03@3x.png 3x"/>
                            </div>
                            <p class="has-text-weight-bold has-text-centered small-top-bottom-margin">Agent
                                reporting</p>
                            <p class="has-text-centered">For larger teams, understand how your agents perform and
                                identify opportunities for improvement.</p>
                        </slide>
                    </carousel>
                </div>
            </div>
        </section>
        <!-- BECOME A BUSINESS -->
        <div class="container become-a-business">
            <div class="columns is-centered">
                <div class="column is-8-desktop is-10-tablet is-fullmobile is-8-widescreen">
                    <section class="section">
                        <h1 class="title has-text-centered">Become a Hellopeter business</h1>
                        <div class="buttons is-centered">
                            <div class="column has-text-right">
                                <a href="/onboard/create/free/monthly"
                                             class="button is-button-white is-button-xlarge is-color-3056E1 has-text-centered is-fullwidth">
                                    GET STARTED FOR FREE
                                </a>
                            </div>
                            <div class="column">
                                <a href="https://biz.hellopeter.com/plans"
                                             class="button is-button-white-outline is-button-xlarge has-text-centered is-fullwidth">
                                    VIEW OUR PACKAGES
                                </a>
                            </div>
                        </div>
                        <p class="has-text-centered has-text-white">
                            Or <a class="has-text-white has-text-weight-bold has-text-underline" :href="`${cfUrl}/contact-us`">get in touch</a>
                            with our team to learn more, we'd love to hear from you.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef */
  export default {
    name: 'Features',
    metaInfo: {
      title: 'Business Portal | Hellopeter - Features'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Features'
      })
    },
    data () {
      return {
        slidesPerPage: 1,
        cfUrl: process.env.HP_APP_URL
      }
    },
    methods: {
      jumpTo (anchor) {
        location.href = '#' + anchor
      }
    }
  }
</script>
<style scoped>
    .is-hover:hover {
        cursor: pointer;
    }

    .section .section {
        padding: 3rem 0 3rem 0;
    }

    .max500 {
        max-width: 500px;
        margin-right: auto;
        margin-left: auto;
    }

    .title {
        color: #555E65;
    }

    .section {
        padding: 5rem 3rem 5rem 3rem;
    }

    #overview > .columns:first-child > .column > p {
        width: 500px;
        margin: 2rem auto 1rem auto;
    }

    #overview .is-centered > img {
        margin-left: auto;
        margin-right: auto;
    }

    #overview > .container {
        margin-top: 1rem;
    }

    #overview > .container p {
        margin-top: 1rem;
        color: #31AAE1;
    }

    #get-found {
        background-image: url("/static/img/features/desktop/backgrounds@2x.jpg");
        background-size: cover;
        color: #ffffff;
    }

    #get-found h1 {
        color: #ffffff;
        font-weight: 700 !important;
    }

    #get-found .media-content .content p {
        font-size: 0.9rem;
        text-align: justify;
        max-width: 500px;
    }

    .image.get-found-image {
        width: 79px;
        height: 100px;
    }

    .image.get-found-image > img {
        width: 79px;
        height: 100px;
    }

    #get-found .media-left {
        margin-right: 2rem;
        margin-top: 0.4rem;
    }

    #get-found-image {
        max-width: 1100px;
        width: 100%;
        margin: 3rem auto 3rem auto;
        display: block;
    }

    #on-site-presence-icon, #google-presence-icon {
        width: 38px;
        height: 38px;
    }

    .container.is-hidden-mobile .is-size-6-tablet {
        font-size: 0.9rem !important;
    }

    .small-top-bottom-margin {
        margin-top: 1rem;
        margin-bottom: 0.7rem;
    }

    .listing-blurb {
        max-width: 250px;
    }

    #rich-snippets-icon {
        width: 42px;
        height: 38px;
    }

    #top-business-icon {
        width: 33px;
        height: 38px;
    }

    .VueCarousel p {
        font-size: 0.9rem !important;
    }

    .VueCarousel p:nth-child(1) {
        font-weight: 700 !important;
    }

    #slide-google-presence, #slide-google-presence-2, #slide-google-star-ratings, #slide-onsite-presence, #slide-top-business {
        margin: 2rem auto 0 auto;
    }

    #slide-google-presence, #slide-google-presence-2 {
        width: 260px;
        height: 247px;
    }

    #slide-google-star-ratings {
        width: 158px;
        height: 247px;
    }

    #slide-onsite-presence {
        width: 158px;
        height: 247px;
    }

    #slide-top-business {
        width: 158px;
        height: 247px;
    }

    #build-a-brand {
        color: #58595b;
        background-image: url("/static/img/features/desktop/backgrounds-2@2x.jpg");
        background-size: cover;
    }

    #build-a-brand h1 {
        color: #58595b;
        font-weight: 700 !important;
    }

    #build-a-brand .media-content .content p {
        font-size: 0.9rem;
        text-align: justify;
        max-width: 500px;
    }

    #build-a-brand .media-left {
        margin-right: 2rem;
    }

    .image.build-a-brand-image, .image.build-a-brand-image > img {
        width: 110px;
        height: 100px;
        padding-left: 0;
        padding-right: 0;
    }

    #build-a-brand-image {
        max-width: 1061px;
        width: 100%;
        margin: 3rem auto 3rem auto;
        display: block;
    }

    #collect-more-reviews-icon {
        width: 40px;
        height: 38px;
    }

    #trust-index-rating-icon {
        width: 31px;
        height: 38px;
    }

    #social-share-icon {
        width: 38px;
        height: 38px;
    }

    #slide-collect-reviews {
        width: 260px;
        height: 255px;
    }

    #slide-trust-index {
        width: 259px;
        height: 211px;
    }

    #slide-social-sharing {
        width: 260px;
        height: 202px;
    }

    #slide-collect-reviews, #slide-trust-index, #slide-social-sharing {
        margin-right: auto;
        margin-left: auto;
    }

    .mar-bottom-only {
        margin-bottom: 2rem;
    }

    #engage {
        background-image: url("/static/img/features/desktop/backgrounds-3@2x.jpg");
        background-size: cover;
        color: #ffffff;
    }

    #engage h1 {
        color: #ffffff;
        font-weight: 700 !important;
    }

    #engage .media-content .content p {
        font-size: 0.9rem;
        text-align: justify;
        max-width: 570px;
    }

    .image.engage-image, .image.engage-image {
        width: 100px;
        height: 100px;
    }

    #engage .media-left {
        margin-right: 2rem;
    }

    #engage-image {
        max-width: 1059px;
        width: 100%;
        margin: 1.5rem auto 1rem auto;
        display: block;
    }

    #manage-reviews-icon {
        width: 43px;
        height: 38px;
    }

    #collect-nps-icon {
        width: 38px;
        height: 38px;
    }

    #slide-manage-reviews {
        width: 260px;
    }

    #slide-collect-nps {
        width: 131px;
    }

    #slide-collect-nps, #slide-manage-reviews {
        height: 198px;
        margin-right: auto;
        margin-left: auto;
    }

    #data-inform {
        background-image: url("/static/img/features/desktop/backgrounds-4@2x.jpg");
        background-size: cover;
        color: #58595b;
    }

    #data-inform h1 {
        color: #58595b;
        font-weight: 700 !important;
    }

    #data-inform .media-content .content p {
        font-size: 0.9rem;
        text-align: justify;
        max-width: 570px;
    }

    #data-inform .media-left {
        margin-right: 2rem;
    }

    #data-inform-image {
        max-width: 1080px;
        width: 100%;
        margin: 3rem auto 3rem auto;
        display: block;
    }

    #dashboard-icon, #reporting-icon, #on-site-icon, #agent-reporting-icon {
        width: 61px;
        height: 38px;
    }

    #slide-dashboard {
        width: 259px;
        height: 154px;
    }

    #slide-reporting {
        width: 259px;
        height: 150px;
    }

    #slide-onsite-google, #slide-onsite-google-2 {
        width: 175px;
        height: 150px;
    }

    #slide-onsite-google, #slide-onsite-google-2, #slide-reporting, #slide-dashboard {
        margin-right: auto;
        margin-left: auto;
    }

    .become-a-business {
        padding: 3rem;
        width: 100%;
        max-width: 100%;
        background-color: #3056E1;
        background-image: url("/static/img/landing/stars.png");
        background-size: cover;
    }

    .become-a-business h1 {
        color: #ffffff;
    }

    .become-a-business p {
        max-width: 100% !important;
    }

    @media screen and (min-width: 1024px) {
        .is-size-6-desktop {
            font-size: 1.1rem !important;
        }

        #get-found h1 {
            font-size: 2rem !important;
        }
    }

    @media screen and (max-width: 767px) {
        .section {
            margin: 0;
            padding: 2rem 0 2rem 0;
        }

        #overview > .columns:first-child > .column > p {
            width: auto;
            margin: 1rem;
            padding: 0.5rem 2.3rem 0 2.3rem;
            font-size: 0.9rem;
        }

        .column.is-12-mobile {
            -webkit-box-flex: 0;
            -ms-flex: none;
            flex: none;
            width: 100%;
            margin: 1rem 0;
        }

        .is-size-3-mobile {
            font-size: 1.8rem !important;
        }

        .title {
            padding-left: 1rem;
            padding-right: 1rem;
        }

        .card, .columns > .column {
            margin-top: 0;
            margin-left: 0;
            margin-right: 0;
        }

        .image > img {
            width: 60px;
            height: 60px;
            z-index: 3;
        }

        .mobile-left-right-padding {
            padding-left: 1.5rem;
            padding-right: 1.5rem;
        }

        .image.get-found-image {
            width: 100%;
            margin-top: 1.5rem;
        }

        .image.get-found-image > img {
            width: 62px;
            height: 80px;
            margin-left: auto;
            margin-right: auto;
        }

        #get-found .title {
            padding-left: 3rem;
            padding-right: 3rem;
            padding-top: 0.7rem;
        }

        #build-a-brand .title {
            padding-left: 3rem;
            padding-right: 3rem;
            padding-top: 1.7rem;
        }

        .columns.is-mobile.is-hidden-tablet p {
            font-size: 0.9rem;
            padding-right: 2.7rem;
            padding-left: 2.7rem;
            width: 100%;
        }

        .image.build-a-brand-image, .image.build-a-brand-image > img {
            width: 88px;
            height: 80px;
            padding-left: 0;
            padding-right: 0;
            margin-left: auto;
            margin-right: auto;
        }

        .image.engage-image, .image.engage-image > img {
            width: 80px;
            height: 80px;
            padding-left: 0;
            padding-right: 0;
            margin-left: auto;
            margin-right: auto;
            margin-bottom: 1.7rem;
        }

        .image.data-inform-image, .image.data-inform-image > img {
            width: 80px;
            height: 80px;
            padding-left: 0;
            padding-right: 0;
            margin: 2rem auto 1.7rem auto;
        }

        #engage .columns.is-mobile.is-hidden-tablet p, #data-inform .columns.is-mobile.is-hidden-tablet p {
            margin-bottom: 1.7rem;
        }

        #data-inform .title {
            padding-left: 3rem;
            padding-right: 3rem;
        }

        .become-a-business {
            padding-left: 0;
            padding-right: 0;
        }

        .become-a-business .section {
            padding-left: 0;
            padding-right: 0;
        }
    }

    @media screen and (min-width: 768px) and (max-width: 1023px) {
        .tablet-outer-pad {
            padding-left: 3rem;
            padding-right: 3rem;
        }
    }

    .has-text-underline {
        text-decoration: underline;
    }

</style>



// WEBPACK FOOTER //
// src/pages/Features.vue